import { toast } from "react-toastify";
import { GET, POST, PUT, DELETE, DELETEDATA } from "./axios.api";
const BASE_URL = process.env.REACT_APP_API;

// ADMIN LOGIN
export const loginUser = async (payload) => {
  const res = await POST(`${BASE_URL}api/user/login`, payload);
  return res;
};

// GET Data
export const getData = async (url) => {
  const res = await GET(`${BASE_URL}${url} `);
  return res;
};

// GET Data by Post
export const getDataByPost = async (url, data) => {
  try {
    const res = await POST(`${BASE_URL}${url}`, data);
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong!"
    );
    throw error;
  }
};

// ADD Data
export const addData = async (url, data) => {
  try {
    const res = await POST(`${BASE_URL}${url}`, data);
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong!"
    );
    throw error;
  }
};

// UPDATE Data
export const updateData = async (url, data) => {
  try {
    const res = await PUT(`${BASE_URL}${url}`, data);
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong!"
    );
    throw error;
  }
};

// DELETE Data
export const deleteData = async (url) => {
  try {
    const res = await DELETE(`${BASE_URL}${url}`);
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong!"
    );
    throw error;
  }
};

// DELETE w Payload
export const deleteDataPayload = async (url, data) => {
  try {
    const res = await DELETEDATA(`${BASE_URL}${url}`, { data });
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong!"
    );
    throw error;
  }
};
//image link
export const ImageLink = (path) => {
  if (!path) return "";
  return `${BASE_URL}${path}`;
};

